/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */

import { Injectable } from "@angular/core";
import { ILoggedIn } from "../model/user.model";
import { LoginResponse } from "../model/loginResponse.model";
import { FeatureKey } from "../model/shared.model";

@Injectable({
  providedIn: "root"
})
export class UserInfoService {
  id: string;
  user: string;
  tenant: string;
  associate_id: string;
  company_name: string;
  api = "";
  maillink_api = "";
  image_url: string;
  initials: string;
  clientAppBearer: string;
  clientAppExpiration: number;
  enabledFeatures: string[] = [];

  constructor() { }

  setUserInfo(auth: ILoggedIn) {
    this.id = auth.id;
    this.user = auth.user;
    this.tenant = auth.tenant;
    this.associate_id = auth.associate_id;
    this.company_name = auth.company_name;
    this.api = auth.api;
    this.maillink_api = auth.maillink_api;
    this.image_url = auth.image_url;
    this.initials = auth.initials;
    this.enabledFeatures = auth.enabledFeatures ?? [];
  }

  hasFeature(key: FeatureKey): boolean {
    return this.enabledFeatures.includes(key);
  }

  setClientAppInfo(loginResponse: LoginResponse): void {
    this.clientAppBearer = loginResponse.bearer;
    this.clientAppExpiration = loginResponse.expiration;
  }

  removeClientAppInfo(): void {
    this.clientAppBearer = null;
    this.clientAppExpiration = null;
  }
}
